// PRODUCTION — live-updates change-type badge (Added / Updated / Removed).
import React, { memo } from 'react'
import tw, { TwStyle } from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'

type ChangeKind = 'created' | 'updated' | 'deleted' | 'other'

interface ChangeStyle {
  label: string
  chip: TwStyle
  chipText: TwStyle
}

const CHANGE_STYLES: Record<ChangeKind, ChangeStyle> = {
  created: {
    label: 'Added',
    chip: tw`bg-success-200`,
    chipText: tw`text-success-500`,
  },
  updated: {
    label: 'Updated',
    chip: tw`bg-primary-100`,
    chipText: tw`text-primary-500`,
  },
  deleted: {
    label: 'Removed',
    chip: tw`bg-critical-50`,
    chipText: tw`text-critical-500`,
  },
  other: {
    label: 'Changed',
    chip: tw`bg-shades-100`,
    chipText: tw`text-shades-600`,
  },
}

/** Map a `*_created | *_updated | *_deleted` event string to a visual kind. */
function changeKind(changeType: string): ChangeKind {
  if (changeType.includes('created')) {
    return 'created'
  }

  if (changeType.includes('deleted')) {
    return 'deleted'
  }

  if (changeType.includes('updated')) {
    return 'updated'
  }

  return 'other'
}

const ChangeChipComponent = ({ changeType }: { changeType: string }) => {
  const style = CHANGE_STYLES[changeKind(changeType)]

  return <Chip text={style.label} className={style.chip} textClassName={style.chipText} />
}

export const ChangeChip = memo(ChangeChipComponent)
